import React from "react";
import { observer } from "mobx-react";
import { Modal } from "@lib/modal";

import { BetDetailsModalStore } from "@state/stores/my-bets/BetDetailsModalStore";
import {
	BetDetailsModalBody,
	BetDetailsModalHeader,
	BetDetailsModalFooter,
} from "./components";

import { BetDetailsModalStoreContext } from "@state/context/my-bets/BetDetailsModalStoreContext";
import { BetSlipReceiptModalStore } from "@state/stores/my-bets/BetSlipReceiptModalStore";
import { SharedLoaderSpinner } from "@components/loader/shared";

export const BetDetailsModal = observer(function BetDetailsModal(props: {
	store: BetDetailsModalStore | BetSlipReceiptModalStore;
}) {
	const store = props.store;

	if (!store.isModalOpen) {
		return null;
	}

	if (store.loader.isLoading || store.isMyBetsLoading) {
		return (
			<div className="popup popup--play popup--bbp">
				<div className="popup__card popup--play__card">
					<SharedLoaderSpinner />
				</div>
			</div>
		);
	}

	return (
		<Modal>
			<BetDetailsModalStoreContext.Provider value={store}>
				<div className="popup popup--play popup--bbp popup--bs">
					<div className="popup__card popup--play__card popup--bs__card">
						<BetDetailsModalHeader betSlip={store.currentBet} />
						<BetDetailsModalBody currentBet={store.currentBet} />
						<BetDetailsModalFooter currentBet={store.currentBet} />
					</div>
				</div>
			</BetDetailsModalStoreContext.Provider>
		</Modal>
	);
});
